import React from "react";
import {Text, TextAs, TextSizes, Tooltip} from "@clockout-dev/design-elements";
import {buildJobRowModel} from "../../audit.model";
import styles from "../../styles/pills.module.scss";

/**
 * Uppercase status pill for one intake job. `completed` splits on
 * `accepted`; rejected jobs carry the mapped `REJECTION_REASON_LABELS`
 * tooltip so the reason is one hover away from the table.
 *
 * @param {Object} props
 * @param {Object} props.job — one row from the jobs endpoint
 */
function JobStatusPill({job}) {
    const model = buildJobRowModel(job);

    const pill = (
        <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={`${styles.tag} ${styles[`tone_${model.statusTone}`]}`}>
            {model.statusLabel}
        </Text>
    );

    return model.reasonLabel ? <Tooltip title={model.reasonLabel}>{pill}</Tooltip> : pill;
}

export default JobStatusPill;
